import { useQuery } from '@tanstack/react-query';
import { EntityWithFieldMetadata } from 'src/UI/dynamicUI/types';

type Props = {
  id: string;
  entityType: string;
  clientId: string;
};

export const useEntity = ({ id, clientId, entityType }: Props) => {
  const { data, isLoading, isError, error, refetch } = useQuery<EntityWithFieldMetadata>({
    queryKey: ['clients', clientId, entityType, 'entities', id],
    enabled: !!id && !!clientId && !!entityType,
  });

  return {
    entityData: data ?? undefined,
    isLoading,
    isError,
    refetch,
    error,
  };
};
